// src/examples/Navbars/TopNavBar.js
import React, { useEffect, useRef, useState } from "react";
import AdminTopNavBar from "./AdminTopNavBar";
import UserTopNavBar from "./UserTopNavBar";
import SalesTopNavBar from "./SalesTopNavBar";
import { useAuth } from "context/AuthContext";
import { getAccountMeCached } from "lib/axios";

const normalizeRole = (r) =>
  String(r || "")
    .toLowerCase()
    .trim();

const getStoredRole = () =>
  normalizeRole(sessionStorage.getItem("role") || localStorage.getItem("role"));

const TopNavBar = () => {
  const { auth } = useAuth();
  const [resolvedRole, setResolvedRole] = useState(() => getStoredRole());
  const fetchedOnce = useRef(false);

  // Advance when context provides a non-empty role (never regress to empty)
  useEffect(() => {
    const next = normalizeRole(auth?.role || sessionStorage.getItem("role"));
    if (next) {
      setResolvedRole(next);
      try {
        localStorage.setItem("role", next);
      } catch {}
    }
  }, [auth?.role]);

  // Self-hydrate from /contractors/me once if auth context is not yet set
  useEffect(() => {
    if (auth?.role || fetchedOnce.current) return;
    fetchedOnce.current = true;
    (async () => {
      try {
        const res = await getAccountMeCached({ validateStatus: (s) => s < 500 });
        const next = normalizeRole(res?.data?.role);
        if (next) {
          setResolvedRole(next);
          try {
            localStorage.setItem("role", next);
          } catch {}
        }
      } catch {
        /* ignore */
      }
    })();
  }, [resolvedRole]);

  // Always show a bar; default to user if unknown
  if (resolvedRole === "admin") return <AdminTopNavBar />;
  if (resolvedRole === "sales") return <SalesTopNavBar />;
  return <UserTopNavBar />;
};

export default TopNavBar;
